import * as Actions from '../actionsgazeta';

const initialState = [];

const noticiasCapa = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_COLUNAS_COLUNISTA_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_COLUNAS_COLUNISTA_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default noticiasCapa;
